import React from "react";
import { Modal } from "./Modal";
import { AlertCircle } from "lucide-react";

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  showCancel?: boolean;
}

export function InfoDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  showCancel,
}: ConfirmationDialogProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6">
        <div className="flex items-center mb-4">
          <AlertCircle className="h-6 w-6 text-[#E47E7B] mr-2" />
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        </div>
        <p className="mb-6 text-gray-500">{message}</p>
        <div className="flex justify-end space-x-3 gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg bg-gray-100 px-4 py-2 text-gray-700 hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-white bg-[#E47E7B] rounded-md hover:bg-[#D16B68] transition-colors"
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
}
